/* lm-carousel — seamless natural-width marquee belt.
   Clones the slide set on both sides, then translates the track each frame. The render
   uses an exact modulo of one set width, so the loop never jumps — unlike the live build's
   non-integer reset. Pauses on hover, draggable (mouse + touch), still draggable under
   reduced-motion (just no auto-scroll), and paused while the tab is hidden.
   Theme-editor aware: re-inits on section load and tears down on unload (no leaks); clones
   drop their editor hooks so only the original slides are selectable in the editor. */
(function () {
  'use strict';

  var SIDE = 2;                 // clone sets on each side → (2*SIDE + 1) identical sets
  function mod(a, n) { return ((a % n) + n) % n; }

  function init(wrap) {
    if (!wrap || wrap._lmDestroy) return;   // already initialised (avoid double-cloning)
    var track = wrap.querySelector('.lm-carousel__track');
    if (!track) return;
    var originals = Array.prototype.slice.call(track.children);
    if (!originals.length) return;

    // clone without the theme-editor block hooks, so selecting a slide in the editor
    // highlights only the original, not its five duplicates
    function makeClone(node) {
      var c = node.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      Array.prototype.slice.call(c.attributes).forEach(function (a) {
        if (a.name.indexOf('data-shopify') === 0) c.removeAttribute(a.name);
      });
      return c;
    }

    var i, j;
    for (i = 0; i < SIDE; i++) {
      for (j = 0; j < originals.length; j++) track.appendChild(makeClone(originals[j]));
    }
    for (i = 0; i < SIDE; i++) {
      for (j = originals.length - 1; j >= 0; j--) track.insertBefore(makeClone(originals[j]), track.firstChild);
    }
    var SETS = 2 * SIDE + 1;

    var section = wrap.closest('.lm-carousel');
    var speed = parseFloat(section && section.style.getPropertyValue('--lm-belt-speed')) || 9; // px per second

    var oneSet = 0, base = 0, position = 0, last = null;
    var hovered = false, dragging = false, startX = 0, startPos = 0, raf = null;

    function measure() {
      oneSet = track.scrollWidth / SETS;
      base = SIDE * oneSet;
      render();
    }
    function render() {
      if (!oneSet) return;
      track.style.transform = 'translateX(' + (-(base + mod(position, oneSet))) + 'px)';
    }
    function tick(ts) {
      if (last == null) last = ts;
      var dt = ts - last;
      last = ts;
      if (!hovered && !dragging && dt < 100) {           // skip huge gaps (tab was backgrounded)
        position += speed * dt / 1000;                    // speed is px/second
        if (position > 1e6) position = mod(position, oneSet); // keep the float small
        render();
      }
      raf = requestAnimationFrame(tick);
    }
    function start() { last = null; if (!raf) raf = requestAnimationFrame(tick); }
    function stop() { if (raf) { cancelAnimationFrame(raf); raf = null; } }

    var getX = function (e) { return e.touches ? e.touches[0].clientX : e.pageX; };
    function down(e) { dragging = true; startX = getX(e); startPos = position; wrap.classList.add('is-dragging'); }
    function moveDrag(e) { if (!dragging) return; position = startPos + (startX - getX(e)); render(); }
    function up() { if (!dragging) return; dragging = false; wrap.classList.remove('is-dragging'); }
    function onEnter() { hovered = true; }
    function onLeave() { hovered = false; }
    function onVis() { if (document.hidden) stop(); else start(); }

    wrap.addEventListener('mouseenter', onEnter);
    wrap.addEventListener('mouseleave', onLeave);
    wrap.addEventListener('mousedown', down);
    window.addEventListener('mousemove', moveDrag);
    window.addEventListener('mouseup', up);
    wrap.addEventListener('touchstart', down, { passive: true });
    wrap.addEventListener('touchmove', moveDrag, { passive: true });
    wrap.addEventListener('touchend', up);
    window.addEventListener('resize', measure);
    document.addEventListener('visibilitychange', onVis);

    // measure now (intrinsic width/height attrs give correct sizes pre-load) and again on load
    measure();
    var imgs = track.querySelectorAll('img');
    Array.prototype.forEach.call(imgs, function (im) {
      if (!im.complete) im.addEventListener('load', measure, { once: true });
    });

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce) start();

    // teardown for the theme editor (section reload) so nothing leaks
    wrap._lmDestroy = function () {
      stop();
      window.removeEventListener('mousemove', moveDrag);
      window.removeEventListener('mouseup', up);
      window.removeEventListener('resize', measure);
      document.removeEventListener('visibilitychange', onVis);
      wrap._lmDestroy = null;
    };
  }

  function boot() { document.querySelectorAll('[data-lm-carousel]').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', function (e) {
    var w = e.target.querySelector('[data-lm-carousel]');
    if (w) init(w);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var w = e.target.querySelector('[data-lm-carousel]');
    if (w && w._lmDestroy) w._lmDestroy();
  });
})();
